import React from "react";
import { CSSTransition } from "react-transition-group";

export const Fade = props => {
    return (
        <CSSTransition
            in={props.in}
            appear={props.appear}
            enter={props.enter}
            timeout={props.timeout}
            unmountOnExit
            classNames="fade">
            {props.children}
        </CSSTransition>
    );
};

Fade.defaultProps = {
    in: true,
    appear: true,
    enter: true,
    timeout: 300
};
